const data = [
360,0.17556,0.00529,0.81915,
361,0.17548,0.00529,0.81923,
362,0.17540,0.00528,0.81932,
363,0.17532,0.00527,0.81941,
364,0.17524,0.00526,0.81950,
365,0.17516,0.00526,0.81958,
366,0.17509,0.00525,0.81966,
367,0.17501,0.00524,0.81975,
368,0.17494,0.00523,0.81983,
369,0.17488,0.00522,0.81990,
370,0.17482,0.00522,0.81996,
371,0.17477,0.00523,0.82000,
372,0.17472,0.00524,0.82004,
373,0.17466,0.00524,0.82010,
374,0.17459,0.00522,0.82019,
375,0.17451,0.00518,0.82031,
376,0.17441,0.00513,0.82046,
377,0.17431,0.00507,0.82062,
378,0.17422,0.00502,0.82076,
379,0.17416,0.00498,0.82086,
380,0.17411,0.00496,0.82093,
381,0.17409,0.00496,0.82095,
382,0.17407,0.00497,0.82096,
383,0.17406,0.00498,0.82096,
384,0.17404,0.00498,0.82098,
385,0.17401,0.00498,0.82101,
386,0.17397,0.00497,0.82106,
387,0.17393,0.00494,0.82113,
388,0.17389,0.00493,0.82118,
389,0.17384,0.00492,0.82124,
390,0.17380,0.00492,0.82128,
391,0.17376,0.00492,0.82132,
392,0.17370,0.00494,0.82136,
393,0.17366,0.00494,0.82140,
394,0.17361,0.00494,0.82145,
395,0.17356,0.00492,0.82152,
396,0.17351,0.00490,0.82159,
397,0.17347,0.00486,0.82167,
398,0.17342,0.00484,0.82174,
399,0.17338,0.00481,0.82181,
400,0.17334,0.00480,0.82186,
401,0.17329,0.00479,0.82192,
402,0.17324,0.00478,0.82198,
403,0.17317,0.00478,0.82205,
404,0.17310,0.00477,0.82213,
405,0.17302,0.00478,0.82220,
406,0.17293,0.00478,0.82229,
407,0.17284,0.00479,0.82237,
408,0.17275,0.00480,0.82245,
409,0.17266,0.00480,0.82254,
410,0.17258,0.00480,0.82262,
411,0.17249,0.00480,0.82271,
412,0.17239,0.00480,0.82281,
413,0.17230,0.00480,0.82290,
414,0.17219,0.00482,0.82299,
415,0.17209,0.00483,0.82308,
416,0.17198,0.00486,0.82316,
417,0.17187,0.00489,0.82324,
418,0.17174,0.00494,0.82332,
419,0.17159,0.00501,0.82340,
420,0.17141,0.00510,0.82349,
421,0.17121,0.00521,0.82358,
422,0.17099,0.00533,0.82368,
423,0.17077,0.00547,0.82376,
424,0.17054,0.00562,0.82384,
425,0.17030,0.00579,0.82391,
426,0.17005,0.00597,0.82398,
427,0.16978,0.00618,0.82404,
428,0.16950,0.00640,0.82410,
429,0.16920,0.00664,0.82416,
430,0.16888,0.00690,0.82422,
431,0.16853,0.00718,0.82429,
432,0.16815,0.00749,0.82436,
433,0.16775,0.00782,0.82443,
434,0.16733,0.00817,0.82450,
435,0.16690,0.00855,0.82455,
436,0.16645,0.00896,0.82459,
437,0.16598,0.00940,0.82462,
438,0.16548,0.00987,0.82465,
439,0.16496,0.01035,0.82469,
440,0.16441,0.01086,0.82473,
441,0.16383,0.01138,0.82479,
442,0.16321,0.01194,0.82485,
443,0.16255,0.01252,0.82493,
444,0.16185,0.01314,0.82501,
445,0.16111,0.01379,0.82510,
446,0.16031,0.01449,0.82520,
447,0.15947,0.01523,0.82530,
448,0.15857,0.01602,0.82541,
449,0.15763,0.01684,0.82553,
450,0.15664,0.01771,0.82565,
451,0.15560,0.01861,0.82579,
452,0.15452,0.01956,0.82592,
453,0.15340,0.02055,0.82605,
454,0.15222,0.02161,0.82617,
455,0.15099,0.02274,0.82627,
456,0.14969,0.02395,0.82636,
457,0.14834,0.02525,0.82641,
458,0.14693,0.02663,0.82644,
459,0.14547,0.02812,0.82641,
460,0.14396,0.02970,0.82634,
461,0.14241,0.03139,0.82620,
462,0.14080,0.03321,0.82599,
463,0.13912,0.03520,0.82568,
464,0.13737,0.03740,0.82523,
465,0.13550,0.03988,0.82462,
466,0.13351,0.04269,0.82380,
467,0.13137,0.04588,0.82275,
468,0.12909,0.04945,0.82146,
469,0.12666,0.05343,0.81991,
470,0.12412,0.05780,0.81808,
471,0.12147,0.06259,0.81594,
472,0.11870,0.06783,0.81347,
473,0.11581,0.07358,0.81061,
474,0.11278,0.07989,0.80733,
475,0.10960,0.08684,0.80356,
476,0.10626,0.09449,0.79925,
477,0.10278,0.10286,0.79436,
478,0.09913,0.11201,0.78886,
479,0.09531,0.12194,0.78275,
480,0.09129,0.13270,0.77601,
481,0.08708,0.14432,0.76860,
482,0.08268,0.15687,0.76045,
483,0.07812,0.17042,0.75146,
484,0.07344,0.18503,0.74153,
485,0.06871,0.20072,0.73057,
486,0.06399,0.21747,0.71854,
487,0.05932,0.23525,0.70543,
488,0.05467,0.25409,0.69124,
489,0.05003,0.27400,0.67597,
490,0.04539,0.29498,0.65963,
491,0.04076,0.31698,0.64226,
492,0.03620,0.33990,0.62390,
493,0.03176,0.36360,0.60464,
494,0.02749,0.38792,0.58459,
495,0.02346,0.41270,0.56384,
496,0.01970,0.43776,0.54254,
497,0.01627,0.46295,0.52078,
498,0.01318,0.48821,0.49861,
499,0.01048,0.51340,0.47612,
500,0.00817,0.53842,0.45341,
501,0.00628,0.56307,0.43065,
502,0.00487,0.58712,0.40801,
503,0.00398,0.61045,0.38557,
504,0.00364,0.63301,0.36335,
505,0.00386,0.65482,0.34132,
506,0.00464,0.67590,0.31946,
507,0.00601,0.69612,0.29787,
508,0.00799,0.71534,0.27667,
509,0.01060,0.73341,0.25599,
510,0.01387,0.75019,0.23594,
511,0.01777,0.76561,0.21662,
512,0.02224,0.77963,0.19813,
513,0.02727,0.79211,0.18062,
514,0.03282,0.80293,0.16425,
515,0.03885,0.81202,0.14913,
516,0.04533,0.81939,0.13528,
517,0.05218,0.82516,0.12266,
518,0.05932,0.82943,0.11125,
519,0.06672,0.83227,0.10101,
520,0.07430,0.83380,0.09190,
521,0.08205,0.83409,0.08386,
522,0.08994,0.83329,0.07677,
523,0.09794,0.83159,0.07047,
524,0.10602,0.82918,0.06480,
525,0.11416,0.82621,0.05963,
526,0.12235,0.82277,0.05488,
527,0.13055,0.81893,0.05052,
528,0.13870,0.81478,0.04652,
529,0.14677,0.81040,0.04283,
530,0.15472,0.80586,0.03942,
531,0.16253,0.80124,0.03623,
532,0.17024,0.79652,0.03324,
533,0.17785,0.79169,0.03046,
534,0.18539,0.78673,0.02788,
535,0.19288,0.78163,0.02549,
536,0.20031,0.77640,0.02329,
537,0.20769,0.77105,0.02126,
538,0.21503,0.76559,0.01938,
539,0.22234,0.76002,0.01764,
540,0.22962,0.75433,0.01605,
541,0.23689,0.74852,0.01459,
542,0.24413,0.74262,0.01325,
543,0.25136,0.73661,0.01203,
544,0.25858,0.73051,0.01091,
545,0.26578,0.72432,0.00990,
546,0.27296,0.71806,0.00898,
547,0.28013,0.71172,0.00815,
548,0.28729,0.70532,0.00739,
549,0.29445,0.69884,0.00671,
550,0.30160,0.69231,0.00609,
551,0.30876,0.68571,0.00553,
552,0.31592,0.67906,0.00502,
553,0.32306,0.67237,0.00457,
554,0.33021,0.66563,0.00416,
555,0.33736,0.65885,0.00379,
556,0.34451,0.65203,0.00346,
557,0.35167,0.64517,0.00316,
558,0.35881,0.63829,0.00290,
559,0.36596,0.63138,0.00266,
560,0.37310,0.62445,0.00245,
561,0.38024,0.61750,0.00226,
562,0.38738,0.61054,0.00208,
563,0.39451,0.60357,0.00192,
564,0.40163,0.59659,0.00178,
565,0.40873,0.58961,0.00166,
566,0.41583,0.58262,0.00155,
567,0.42292,0.57563,0.00145,
568,0.42999,0.56865,0.00136,
569,0.43704,0.56167,0.00129,
570,0.44406,0.55472,0.00122,
571,0.45106,0.54777,0.00117,
572,0.45804,0.54084,0.00112,
573,0.46499,0.53393,0.00108,
574,0.47190,0.52705,0.00105,
575,0.47878,0.52020,0.00102,
576,0.48561,0.51339,0.00100,
577,0.49241,0.50661,0.00098,
578,0.49915,0.49989,0.00096,
579,0.50585,0.49321,0.00094,
580,0.51249,0.48659,0.00092,
581,0.51907,0.48003,0.00090,
582,0.52560,0.47353,0.00087,
583,0.53207,0.46709,0.00084,
584,0.53846,0.46073,0.00081,
585,0.54479,0.45443,0.00078,
586,0.55103,0.44823,0.00074,
587,0.55719,0.44210,0.00071,
588,0.56327,0.43606,0.00067,
589,0.56926,0.43010,0.00064,
590,0.57515,0.42423,0.00062,
591,0.58094,0.41846,0.00060,
592,0.58665,0.41276,0.00059,
593,0.59222,0.40719,0.00059,
594,0.59766,0.40176,0.00058,
595,0.60293,0.39650,0.00057,
596,0.60803,0.39141,0.00056,
597,0.61298,0.38648,0.00054,
598,0.61778,0.38171,0.00051,
599,0.62246,0.37705,0.00049,
600,0.62704,0.37249,0.00047,
601,0.63152,0.36803,0.00045,
602,0.63590,0.36367,0.00043,
603,0.64016,0.35943,0.00041,
604,0.64427,0.35533,0.00040,
605,0.64823,0.35140,0.00037,
606,0.65203,0.34763,0.00034,
607,0.65567,0.34402,0.00031,
608,0.65917,0.34055,0.00028,
609,0.66253,0.33722,0.00025,
610,0.66576,0.33401,0.00023,
611,0.66887,0.33092,0.00021,
612,0.67186,0.32795,0.00019,
613,0.67472,0.32509,0.00019,
614,0.67746,0.32236,0.00018,
615,0.68008,0.31975,0.00017,
616,0.68258,0.31725,0.00017,
617,0.68497,0.31486,0.00017,
618,0.68725,0.31259,0.00016,
619,0.68943,0.31041,0.00016,
620,0.69151,0.30834,0.00015,
621,0.69349,0.30637,0.00014,
622,0.69539,0.30448,0.00013,
623,0.69721,0.30267,0.00012,
624,0.69894,0.30095,0.00011,
625,0.70061,0.29930,0.00009,
626,0.70219,0.29773,0.00008,
627,0.70371,0.29622,0.00007,
628,0.70516,0.29477,0.00007,
629,0.70656,0.29338,0.00006,
630,0.70792,0.29203,0.00005,
631,0.70923,0.29072,0.00005,
632,0.71050,0.28945,0.00005,
633,0.71173,0.28823,0.00004,
634,0.71290,0.28706,0.00004,
635,0.71403,0.28593,0.00004,
636,0.71512,0.28484,0.00004,
637,0.71616,0.28380,0.00004,
638,0.71716,0.28281,0.00003,
639,0.71812,0.28185,0.00003,
640,0.71903,0.28094,0.00003,
641,0.71991,0.28006,0.00003,
642,0.72075,0.27922,0.00003,
643,0.72155,0.27842,0.00003,
644,0.72232,0.27766,0.00002,
645,0.72303,0.27695,0.00002,
646,0.72370,0.27628,0.00002,
647,0.72433,0.27566,0.00001,
648,0.72491,0.27508,0.00001,
649,0.72547,0.27453,0,
650,0.72599,0.27401,0,
651,0.72649,0.27351,0,
652,0.72698,0.27302,0,
653,0.72743,0.27257,0,
654,0.72786,0.27214,0,
655,0.72827,0.27173,0,
656,0.72866,0.27134,0,
657,0.72902,0.27098,0,
658,0.72936,0.27064,0,
659,0.72968,0.27032,0,
660,0.72997,0.27003,0,
661,0.73023,0.26977,0,
662,0.73047,0.26953,0,
663,0.73069,0.26931,0,
664,0.73090,0.26910,0,
665,0.73109,0.26891,0,
666,0.73128,0.26872,0,
667,0.73147,0.26853,0,
668,0.73165,0.26835,0,
669,0.73183,0.26817,0,
670,0.73199,0.26801,0,
671,0.73215,0.26785,0,
672,0.73230,0.26770,0,
673,0.73244,0.26756,0,
674,0.73258,0.26742,0,
675,0.73272,0.26728,0,
676,0.73286,0.26714,0,
677,0.73300,0.26700,0,
678,0.73314,0.26686,0,
679,0.73328,0.26672,0,
680,0.73342,0.26658,0,
681,0.73355,0.26645,0,
682,0.73368,0.26632,0,
683,0.73381,0.26619,0,
684,0.73394,0.26606,0,
685,0.73405,0.26595,0,
686,0.73414,0.26586,0,
687,0.73422,0.26578,0,
688,0.73429,0.26571,0,
689,0.73434,0.26566,0,
690,0.73439,0.26561,0,
691,0.73444,0.26556,0,
692,0.73448,0.26552,0,
693,0.73452,0.26548,0,
694,0.73456,0.26544,0,
695,0.73459,0.26541,0,
696,0.73462,0.26538,0,
697,0.73465,0.26535,0,
698,0.73467,0.26533,0,
699,0.73469,0.26531,0,
700,0.73469,0.26531,0,
701,0.73469,0.26531,0,
702,0.73469,0.26531,0,
703,0.73469,0.26531,0,
704,0.73469,0.26531,0,
705,0.73469,0.26531,0,
706,0.73469,0.26531,0,
707,0.73469,0.26531,0,
708,0.73469,0.26531,0,
709,0.73469,0.26531,0,
710,0.73469,0.26531,0,
711,0.73469,0.26531,0,
712,0.73469,0.26531,0,
713,0.73469,0.26531,0,
714,0.73469,0.26531,0,
715,0.73469,0.26531,0,
716,0.73469,0.26531,0,
717,0.73469,0.26531,0,
718,0.73469,0.26531,0,
719,0.73469,0.26531,0,
720,0.73469,0.26531,0,
721,0.73469,0.26531,0,
722,0.73469,0.26531,0,
723,0.73469,0.26531,0,
724,0.73469,0.26531,0,
725,0.73469,0.26531,0,
726,0.73469,0.26531,0,
727,0.73469,0.26531,0,
728,0.73469,0.26531,0,
729,0.73469,0.26531,0,
730,0.73469,0.26531,0,
731,0.73469,0.26531,0,
732,0.73469,0.26531,0,
733,0.73469,0.26531,0,
734,0.73469,0.26531,0,
735,0.73469,0.26531,0,
736,0.73469,0.26531,0,
737,0.73469,0.26531,0,
738,0.73469,0.26531,0,
739,0.73469,0.26531,0,
740,0.73469,0.26531,0,
741,0.73469,0.26531,0,
742,0.73469,0.26531,0,
743,0.73469,0.26531,0,
744,0.73469,0.26531,0,
745,0.73469,0.26531,0,
746,0.73469,0.26531,0,
747,0.73469,0.26531,0,
748,0.73469,0.26531,0,
749,0.73469,0.26531,0,
750,0.73469,0.26531,0,
751,0.73469,0.26531,0,
752,0.73469,0.26531,0,
753,0.73469,0.26531,0,
754,0.73469,0.26531,0,
755,0.73469,0.26531,0,
756,0.73469,0.26531,0,
757,0.73469,0.26531,0,
758,0.73469,0.26531,0,
759,0.73469,0.26531,0,
760,0.73469,0.26531,0,
761,0.73469,0.26531,0,
762,0.73469,0.26531,0,
763,0.73469,0.26531,0,
764,0.73469,0.26531,0,
765,0.73469,0.26531,0,
766,0.73469,0.26531,0,
767,0.73469,0.26531,0,
768,0.73469,0.26531,0,
769,0.73469,0.26531,0,
770,0.73469,0.26531,0,
771,0.73469,0.26531,0,
772,0.73469,0.26531,0,
773,0.73469,0.26531,0,
774,0.73469,0.26531,0,
775,0.73469,0.26531,0,
776,0.73469,0.26531,0,
777,0.73469,0.26531,0,
778,0.73469,0.26531,0,
779,0.73469,0.26531,0,
780,0.73469,0.26531,0,
781,0.73469,0.26531,0,
782,0.73469,0.26531,0,
783,0.73469,0.26531,0,
784,0.73469,0.26531,0,
785,0.73469,0.26531,0,
786,0.73469,0.26531,0,
787,0.73469,0.26531,0,
788,0.73469,0.26531,0,
789,0.73469,0.26531,0,
790,0.73469,0.26531,0,
791,0.73469,0.26531,0,
792,0.73469,0.26531,0,
793,0.73469,0.26531,0,
794,0.73469,0.26531,0,
795,0.73469,0.26531,0,
796,0.73469,0.26531,0,
797,0.73469,0.26531,0,
798,0.73469,0.26531,0,
799,0.73469,0.26531,0,
800,0.73469,0.26531,0,
801,0.73469,0.26531,0,
802,0.73469,0.26531,0,
803,0.73469,0.26531,0,
804,0.73469,0.26531,0,
805,0.73469,0.26531,0,
806,0.73469,0.26531,0,
807,0.73469,0.26531,0,
808,0.73469,0.26531,0,
809,0.73469,0.26531,0,
810,0.73469,0.26531,0,
811,0.73469,0.26531,0,
812,0.73469,0.26531,0,
813,0.73469,0.26531,0,
814,0.73469,0.26531,0,
815,0.73469,0.26531,0,
816,0.73469,0.26531,0,
817,0.73469,0.26531,0,
818,0.73469,0.26531,0,
819,0.73469,0.26531,0,
820,0.73469,0.26531,0,
821,0.73469,0.26531,0,
822,0.73469,0.26531,0,
823,0.73469,0.26531,0,
824,0.73469,0.26531,0,
825,0.73469,0.26531,0,
826,0.73469,0.26531,0,
827,0.73469,0.26531,0,
828,0.73469,0.26531,0,
829,0.73469,0.26531,0,
830,0.73469,0.26531,0
]


export const CIE_CC_1931_DEG: [number, number, number, number][] = [];
for (let i = 0; i < data.length; i += 4) {
  CIE_CC_1931_DEG.push([
    data[i],
    data[i + 1],
    data[i + 2],
    data[i + 3]
  ] as [number, number, number, number]);
}